import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { senderId: String }

  connect() {
    // Get the current user's ID from a meta tag
    const currentUserId = document.querySelector('meta[name="current-user-id"]')?.content;
    const isMine = currentUserId && currentUserId === this.senderIdValue;

    if (isMine) {
      // It's my message
      this.element.classList.remove('justify-start');
      this.element.classList.add('justify-end');
      
      const bubble = this.element.querySelector('.message-bubble');
      if (bubble) {
        bubble.classList.remove('bg-white', 'dark:bg-slate-700', 'text-slate-900', 'dark:text-white', 'border', 'border-slate-200', 'dark:border-slate-600', 'rounded-bl-sm');
        bubble.classList.add('bg-primary-600', 'text-white', 'rounded-br-sm');
      }
      
      const time = this.element.querySelector('.message-time');
      if (time) {
        time.classList.remove('text-slate-500', 'dark:text-slate-400');
        time.classList.add('text-blue-200');
      }
      
      const attachment = this.element.querySelector('.message-attachment');
      if (attachment) {
        attachment.classList.remove('border-slate-200', 'dark:border-slate-600');
        attachment.classList.add('border-blue-500/50');
        const link = attachment.querySelector('.message-attachment-link');
        if (link) {
          link.classList.remove('text-blue-600', 'dark:text-blue-400');
          link.classList.add('text-white');
        }
      }
    }

    // Always scroll the chat container to the bottom when a new message connects
    const container = document.getElementById("project_messages_" + this.element.closest('[id^="project_messages_"]')?.id.split('_').pop());
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }
}
